module.exports = __webpack_public_path__ + "static/UI pattern 3-b411cd5d107147e4e01b5fa4332988bf.png";